export default "__VITE_ASSET__DC8N1UDv__"